const AssetLoadServiceEvent = {
    LOAD_FILE_COMPLETE: "AssetLoadServiceEvent_LOAD_FILE_COMPLETE",
    LOAD_COMPLETE: "AssetLoadServiceEvent_LOAD_COMPLETE",
    LOAD_PROGRESS: "AssetLoadServiceEvent_LOAD_PROGRESS",
    LOAD_FILE_ERROR: "AssetLoadServiceEvent_LOAD_FILE_ERROR"
};

export default AssetLoadServiceEvent;